"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = require("react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SkeletonBase = _interopRequireDefault(require("./SkeletonBase"));

var _baseValues = require("../constants/baseValues");

var _getSize = require("../operators/getSize");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-radius: 50%;\n\n  width: ", ";\n  height: ", ";\n  min-width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SkeletonCircle = (0, _styledComponents.default)(_SkeletonBase.default).withConfig({
  displayName: "SkeletonCircle",
  componentId: "sc-2tq875-0"
})(_templateObject(), function (_ref) {
  var size = _ref.size;
  return (0, _getSize.getSize)(size);
}, function (_ref2) {
  var size = _ref2.size;
  return (0, _getSize.getSize)(size);
}, function (_ref3) {
  var size = _ref3.size;
  return (0, _getSize.getSize)(size);
});
SkeletonCircle.defaultProps = {
  size: _baseValues.CIRCLE_BASE_SIZE
};
SkeletonCircle.propTypes = {
  size: _react.PropTypes.number
};
var _default = SkeletonCircle;
exports.default = _default;
module.exports = exports.default;